/**
 * Portal-scoped localStorage key map.
 * Every portal gets its own isolated set of 5 keys so that sessions
 * in separate browser tabs never collide with each other.
 */
export const STORAGE_KEYS = {
  superadmin: {
    token:        'superadmin_jff_token',
    permission:   'superadmin_permission',
    user_id:      'superadmin_user_id',
    type_of_user: 'superadmin_type_of_user',
    category:     'superadmin_category',
    delete_permission: 'superadmin_delete_permission',
  },
  exhibitor: {
    token:        'exhibitor_jff_token',
    permission:   'exhibitor_permission',
    user_id:      'exhibitor_user_id',
    type_of_user: 'exhibitor_type_of_user',
    category:     'exhibitor_category',
  },
  buyerAdmin: {
    token:        'buyer_admin_jff_token',
    permission:   'buyer_admin_permission',
    user_id:      'buyer_admin_user_id',
    type_of_user: 'buyer_admin_type_of_user',
    category:     'buyer_admin_category',
  },
  visitorAdmin: {
    token:        'visitor_admin_jff_token',
    permission:   'visitor_admin_permission',
    user_id:      'visitor_admin_user_id',
    type_of_user: 'visitor_admin_type_of_user',
    category:     'visitor_admin_category',
  },
  hotelManagement: {
    token:        'hotel_mgmt_jff_token',
    permission:   'hotel_mgmt_permission',
    user_id:      'hotel_mgmt_user_id',
    type_of_user: 'hotel_mgmt_type_of_user',
    category:     'hotel_mgmt_category',
  },
  cabManagement: {
    token:        'cab_mgmt_jff_token',
    permission:   'cab_mgmt_permission',
    user_id:      'cab_mgmt_user_id',
    type_of_user: 'cab_mgmt_type_of_user',
    category:     'cab_mgmt_category',
  },
  hospitality: {
    token:        'hospitality_jff_token',
    permission:   'hospitality_permission',
    user_id:      'hospitality_user_id',
    type_of_user: 'hospitality_type_of_user',
    category:     'hospitality_category',
  },
  cabService: {
    token:        'cab_service_jff_token',
    permission:   'cab_service_permission',
    user_id:      'cab_service_user_id',
    type_of_user: 'cab_service_type_of_user',
    category:     'cab_service_category',
  },
  agent: {
    token:        'agent_jff_token',
    permission:   'agent_permission',
    user_id:      'agent_user_id',
    type_of_user: 'agent_type_of_user',
    category:     'agent_category',
  },
  associate: {
    token:        'associate_jff_token',
    permission:   'associate_permission',
    user_id:      'associate_user_id',
    type_of_user: 'associate_type_of_user',
    category:     'associate_category',
  },
  sponser: {
    token:        'sponser_jff_token',
    permission:   'sponser_permission',
    user_id:      'sponser_user_id',
    type_of_user: 'sponser_type_of_user',
    category:     'sponser_category',
  },
  adminVip: {
    token:        'adminvip_jff_token',
    permission:   'adminvip_permission',
    user_id:      'adminvip_user_id',
    type_of_user: 'adminvip_type_of_user',
    category:     'adminvip_category',
  },
};
